import API_BASE_URL from './apiConfig';
import { getAuthHeaders } from './authApi';

const BASE = `${API_BASE_URL}/im/job`;
const headers = () => ({ 'Content-Type': 'application/json', ...getAuthHeaders() });

const handleError = async (res) => {
  const e = await res.json().catch(() => ({}));
  throw new Error(e.message || `HTTP ${res.status}`);
};

export const startBackfill = async () => {
  const res = await fetch(`${BASE}/start`, { method: 'POST', headers: headers() });
  if (!res.ok) await handleError(res);
  return res.json();
};

export const pauseBackfill = async () => {
  const res = await fetch(`${BASE}/pause`, { method: 'POST', headers: headers() });
  if (!res.ok) await handleError(res);
  return res.json();
};

export const resumeBackfill = async () => {
  const res = await fetch(`${BASE}/resume`, { method: 'POST', headers: headers() });
  if (!res.ok) await handleError(res);
  return res.json();
};

export const retryFailedWindows = async () => {
  const res = await fetch(`${BASE}/retry-failed`, { method: 'POST', headers: headers() });
  if (!res.ok) await handleError(res);
  return res.json();
};

export const getBackfillStatus = async () => {
  const res = await fetch(`${BASE}/status`, { headers: headers() });
  if (!res.ok) await handleError(res);
  return res.json();
};
